var _excluded = ["color"];

function cov_2edlqpolui() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_icons/NavCloseIcon.tsx";
  var hash = "9e4ee8894bbcb78f1ef047efd33a143466a5ff87";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_icons/NavCloseIcon.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 36
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 17,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 36
          },
          end: {
            line: 7,
            column: 37
          }
        },
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 17,
            column: 9
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 39
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 7,
            column: 47
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 13,
            column: 14
          },
          end: {
            line: 13,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 13,
            column: 42
          },
          end: {
            line: 13,
            column: 47
          }
        }, {
          start: {
            line: 13,
            column: 50
          },
          end: {
            line: 13,
            column: 64
          }
        }],
        line: 13
      },
      "2": {
        loc: {
          start: {
            line: 14,
            column: 16
          },
          end: {
            line: 14,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 14,
            column: 44
          },
          end: {
            line: 14,
            column: 49
          }
        }, {
          start: {
            line: 14,
            column: 52
          },
          end: {
            line: 14,
            column: 66
          }
        }],
        line: 14
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9e4ee8894bbcb78f1ef047efd33a143466a5ff87"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2edlqpolui = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2edlqpolui();

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Flex } from '../../core';
import { colors } from '../../theme/eero';
/** @deprecated */

cov_2edlqpolui().s[0]++;

var NavCloseIcon = function NavCloseIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? (cov_2edlqpolui().b[0][0]++, colors.brand50) : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_2edlqpolui().f[0]++;
  cov_2edlqpolui().s[1]++;
  return /*#__PURE__*/React.createElement(Flex, props, /*#__PURE__*/React.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "close"), /*#__PURE__*/React.createElement("path", {
    d: "M11.256 0.752358C11.1001 0.596137 10.8885 0.508343 10.6678 0.508343C10.4471 0.508343 10.2355 0.596137 10.0796 0.752358L6.00001 4.82366L1.92037 0.744016C1.7645 0.587794 1.55288 0.5 1.3322 0.5C1.11151 0.5 0.899898 0.587794 0.744028 0.744016C0.418657 1.06939 0.418657 1.59498 0.744028 1.92035L4.82367 5.99999L0.744028 10.0796C0.418657 10.405 0.418657 10.9306 0.744028 11.256C1.0694 11.5813 1.595 11.5813 1.92037 11.256L6.00001 7.17633L10.0796 11.256C10.405 11.5813 10.9306 11.5813 11.256 11.256C11.5814 10.9306 11.5814 10.405 11.256 10.0796L7.17634 5.99999L11.256 1.92035C11.573 1.60333 11.573 1.06939 11.256 0.752358Z",
    fill: typeof color === 'string' ? (cov_2edlqpolui().b[1][0]++, color) : (cov_2edlqpolui().b[1][1]++, colors.brand50),
    stroke: typeof color === 'string' ? (cov_2edlqpolui().b[2][0]++, color) : (cov_2edlqpolui().b[2][1]++, colors.brand50)
  })));
};

export default NavCloseIcon;